// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"administration":"c3d352e2","vendors-node_modules_dompurify_dist_purify_es_mjs":"e975e5e7","vendors-node_modules_canvg_lib_index_es_js":"d145492e"}[chunkId] + ".chunk.js";
};